import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ams77vmxsb: FaireBrandEntity = {
  token: "b_ams77vmxsb",
  type: "brand",
  name: "Sauz",
  avatarUrl:
    "https://cdn.faire.com/fastly/81d0b234e9c9773f30674dc8b941d5f33079203699c4751c6725cd2b0255f42d.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/6df4ed729a8801fded5ac7de51f299fe77d2a3f7d96e2577ee11e792eb14dbde.png",
  logoUrl:
    "https://cdn.faire.com/fastly/81d0b234e9c9773f30674dc8b941d5f33079203699c4751c6725cd2b0255f42d.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6df4ed729a8801fded5ac7de51f299fe77d2a3f7d96e2577ee11e792eb14dbde.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.7,
  reviewCount: 14,
  isInsider: true,
  description:
    "The pasta sauce aisle has been boring for decades. We're fixing that.\n\nWe're America's fastest growing pasta sauce brand, making bold, unexpected flavors from ingredients that are actually worth reading: California-grown tomatoes, 100% olive oil, real cheese, real cream, and real butter — no seed oils, no added sugars, no ingredient list that requires a chemistry degree. Just real food that makes dinner feel like a thing again.\n\nFrom Creamy Calabrian Vodka to Salted Pistachio Alfredo to Hot Honey Arrabbiata, every jar is built to turn a regular weeknight into something worth talking about. We're already in Whole Foods, Target, Kroger, Sprouts, Wegmans, and HEB — and our retailers consistently see us outperform on velocity. \n\nYour customers are flavor-forward, label-reading, and looking for something new. SAUZ is the answer!",
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:18:06.697Z",
    importedBy: "entity-db-cli",
  },
};
